import { appStateSelectors } from "../modules/appState";
import { filterSelectors } from "../modules/filters";
import { savedFilterSelectors } from "../modules/savedFilters";

/**
 * If the view filter matches any saved filter, assign the saved filter object
 * to the view filter
 * @param {TimelineRecord} record
 * @returns {TimelineRecord}
 */
const repairFiltersRecord = timelineRecord => {
  let fixedTimelineRecord = timelineRecord;
  const savedFilters = savedFilterSelectors.getSavedFilters(timelineRecord);
  if (savedFilters.size > 0) {
    const openViewIds = appStateSelectors.getOpenViewIds(timelineRecord);
    const filtersById = filterSelectors.getFiltersById(timelineRecord);
    openViewIds.forEach(viewId => {
      const viewFilter = filtersById.get(viewId);
      if (viewFilter) {
        savedFilters.find((sfName, fId) => {
          const sf = filtersById.get(fId);
          if (sf && sf.equals(viewFilter)) {
            fixedTimelineRecord = fixedTimelineRecord.setIn(["data", "filters", "byId", viewId], sf);
            return true;
          }
        });
      }
    });
  }
  return fixedTimelineRecord;
};

export default repairFiltersRecord;
